import styled from 'styled-components';
import { Link } from "react-router-dom";
import colors from 'constants/colors';

export const Menu = styled.nav`
  width: 100%;
  list-style: none;
  display: flex;
  flex-flow: column nowrap;
  row-gap: 24px;
`;

export const Title = styled.div`
  width: 100%;
  background-color: ${colors.black2};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  padding: 8px;
  color: ${colors.white};
`;

export const Item = styled(Link)`
  width: 100%;
  color: ${colors.white};
  background-color: ${({ active }) => (active ? colors.black1 : colors.black2)};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 8px;
  text-decoration: none;

  /* :hover {
    color: ${colors.white};
    background-color: ${colors.darkBlue};
    border-left: 5px solid ${colors.lightBlue};
    padding-left: 17px;
  } */
`;